import { render } from "./ListFacturesPayees.vue?vue&type=template&id=4c534277&scoped=true&ts=true"
import script from "./ListFacturesPayees.vue?vue&type=script&lang=ts"
export * from "./ListFacturesPayees.vue?vue&type=script&lang=ts"

import "./ListFacturesPayees.vue?vue&type=style&index=0&id=4c534277&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c534277"]])

export default __exports__